// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1n9FV","inputDescription":"styles_inputDescription__3Xq37"};